import { Box, Button, Grid, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { BentoBrand } from "schemas/dashboard";
import { Map } from "schemas/functions";

import { makeDeepCopy } from "utils/updateLocalState";

import styles from "../styles";

interface PitchEmailFormProps {
  handleBack?: () => void;
  handleNext: () => void;
  handleSkip?: () => void;
  onboardingForm: Map;
  setOnboardingForm: Dispatch<SetStateAction<Map>>;
  selectedBrand?: BentoBrand;
}

const PitchEmailForm = ({
  handleBack,
  handleNext,
  handleSkip,
  onboardingForm,
  setOnboardingForm,
  selectedBrand,
}: PitchEmailFormProps) => {
  const selectOption = (hasPitchEmail: boolean) => {
    const onboardingFormCopy = makeDeepCopy(onboardingForm);
    onboardingFormCopy.hasPitchEmail = hasPitchEmail;
    setOnboardingForm(onboardingFormCopy);
  };

  return (
    <>
      <Typography variant="h3" gutterBottom sx={{ textAlign: "center" }}>
        <Box
          component="i"
          color="secondary.dark"
          sx={{ pr: 2 }}
          className="fa-solid fa-paper-plane"
        />
        Let's get your pitch down!
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 3, textAlign: "center" }}>
        {selectedBrand ? (
          <>
            Let's work together on writing a pitch to{" "}
            <strong>{selectedBrand.normalizedName}</strong>.{" "}
          </>
        ) : (
          "Before sending your first email on Bento, let's work together on creating your first template. "
        )}
        What would you like to do?
      </Typography>

      <Grid container justifyContent="center" gap={1}>
        <Grid item xs="auto">
          <Button
            sx={[
              styles.pitchButton,
              onboardingForm.hasPitchEmail === true &&
                styles.selectedPitchButton,
            ]}
            variant="outlined"
            onClick={() => selectOption(true)}
            disableElevation
          >
            <Box
              sx={styles.pitchIcon}
              component="i"
              className="fa-solid fa-file-lines"
            />
            Improve my current pitch
          </Button>
        </Grid>
        <Grid item xs="auto">
          <Button
            sx={[
              styles.pitchButton,
              onboardingForm.hasPitchEmail === false &&
                styles.selectedPitchButton,
            ]}
            variant="outlined"
            onClick={() => selectOption(false)}
            disableElevation
          >
            <Box
              sx={styles.pitchIcon}
              component="i"
              className="fa-solid fa-pen-to-square"
            />
            Help me write a new one
          </Button>
        </Grid>
      </Grid>
      <Grid container justifyContent="flex-start" sx={{ mt: 2 }}>
        {handleBack && (
          <Grid item xs="auto">
            <Button onClick={handleBack} color="secondary" disableElevation>
              Back
            </Button>
          </Grid>
        )}
        <Grid item xs></Grid>
        {handleSkip && (
          <Grid item xs="auto">
            <Button color="secondary" onClick={handleSkip} disableElevation>
              Skip
            </Button>
          </Grid>
        )}
        <Grid item xs="auto">
          <Button
            disableElevation
            onClick={() => {
              handleNext();
            }}
            variant="contained"
            disabled={
              onboardingForm.hasPitchEmail !== false &&
              onboardingForm.hasPitchEmail !== true
            }
          >
            Next
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default PitchEmailForm;
